module.exports = __webpack_public_path__ + "static/media/file-de-salmao.bf028a06.jpg";